'use client'

import React, { HTMLAttributes } from 'react'
export interface ContextMenuTextItemProps extends HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
}

export const ContextMenuTextItem = ({ children, ...rest }: ContextMenuTextItemProps) => {
    return (
        <div
            {...rest}
            className={`context-menu__text-item flex w-full text-left select-none py-1 px-2 text-sm density-md:py-2 density-md:px-4 density-lg:py-3 density-lg:px-6 ${
                rest.className ?? ''
            }`}
        >
            <span className="mx-2">{children}</span>
        </div>
    )
}
